import React from 'react';

import Btn from '../../buttons/Btn';
import { SituationOptionGroup } from '../components/SituationOptionGroup';
import { DemarcheSituationStep } from '../types';
import {
  Actions, BackLink, Panel, StepText, StepTitle,
} from './styles';

type SituationStepProps = {
  situationStep: DemarcheSituationStep;
  selectedSituation: string | null;
  onSelectSituation: (value: string) => void;
  onSubmit: () => void;
  backHref: string;
};

const SituationStep: React.FC<SituationStepProps> = ({
  situationStep,
  selectedSituation,
  onSelectSituation,
  onSubmit,
  backHref,
}) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <Panel>
      <StepTitle>{situationStep.question}</StepTitle>
      {situationStep.hint && <StepText>{situationStep.hint}</StepText>}
      <form onSubmit={handleSubmit}>
        <SituationOptionGroup
          name="demarche-situation"
          ariaLabel={situationStep.question}
          options={situationStep.options}
          selectedValue={selectedSituation}
          onSelect={onSelectSituation}
        />
        <Actions>
          <BackLink href={backHref}>Retour</BackLink>
          <Btn
            type="submit"
            name="demarche-funnel-situation"
            text="Continuer"
            block
            disabled={!selectedSituation}
          />
        </Actions>
      </form>
    </Panel>
  );
};

export { SituationStep };
